module.exports = __webpack_public_path__ + "static/no-results-fe6b49992b40bb33d47a0603df0bda39.png";